import Big from 'big.js';

Big.RM = 0;

// truncates without rounding
export function truncate(number, maxDecimalPlaces = 2) {
  if (number === undefined || isNaN(number)) return null;
  if (number === Infinity) return number;
  const numString = new Big(number).toFixed();
  try {
    const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + maxDecimalPlaces + '})?', 'g'); // eslint-disable-line
    const truncated = numString.match(reg)[0];
    const decimalIndex = truncated.indexOf('.');
    if (decimalIndex === -1) {
      return `${truncated}.${'0'.repeat(maxDecimalPlaces)}`;
    }
    const missingFigs = maxDecimalPlaces - (truncated.length - decimalIndex) + 1;
    return missingFigs > 0 ? truncated + '0'.repeat(missingFigs) : truncated;
  } catch (err) {
    console.warn(`truncation error for ${number}, ${maxDecimalPlaces}:`, err); // eslint-disable-line
    return number;
  }
}

// Adds thousands separators
export function formatNumber(number) {
  if (number === undefined || isNaN(number)) return null;
  const numString = `${number}`;
  return numString.replace(/\B(?=(?=\d*\.)(\d{3})+(?!\d))/g, ',');
}

export function formatAndTruncate(number, minTickLength = 2) {
  return formatNumber(truncate(number, minTickLength));
}

export const getOptionsListOfAssets = assets =>
  Object.keys(assets)
    .sort()
    .reduce(
      (acc, asset) => ({
        ...acc,
        [asset]: { label: `${assets[asset]?.name} (${asset})`, icon: { asset } }
      }),
      {}
    );
